import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]
  static values = {
    radioName: String
  }

  connect() {
    // Get all radio buttons with the name specified
    const radioButtons = document.querySelectorAll(`input[name="${this.radioNameValue}"]`)

    // Set initial visibility based on current selection
    this.updateContainerVisibility(radioButtons)

    // Add event listeners to each radio button
    radioButtons.forEach(radio => {
      radio.addEventListener('change', () => this.updateContainerVisibility(radioButtons))
    })
  }

  updateContainerVisibility(radioButtons) {
    // Find the checked radio button
    const checkedRadio = Array.from(radioButtons).find(radio => radio.checked)

    // Show container if the checked value is "true"
    if (checkedRadio && checkedRadio.value === 'true') {
      this.containerTarget.style.display = 'block'
    } else {
      this.containerTarget.style.display = 'none'
    }
  }
}